import { useMemo } from 'react';

import { endOfWeek, startOfWeek } from 'date-fns';

import { Box, CircularProgress, theme } from '@sbv-clients/ui-shared';
import { formatDate } from '@sbv-clients/util-misc';

import { useUnderOverByPositionGet } from '../../../services/dashboard';
import Legends from './components/legends';
import OverUnderTable from './table';

const TABLE_BORDER_COLOR = theme.colors.border.tableLight;

interface OverUnderUtilizationProps {
  positionId: number;
  startDate: Date;
}

const OverUnderUtilizationTable = (props: OverUnderUtilizationProps) => {
  const [startDate, endDate] = useMemo(
    () => [
      formatDate(startOfWeek(new Date(props.startDate))),
      formatDate(endOfWeek(new Date(props.startDate))),
    ],
    [props.startDate]
  );
  const { data = [], isLoading } = useUnderOverByPositionGet({
    positionId: props.positionId,
    startDate,
    endDate,
  });
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Box
      p={4}
      py={6}
      width="100%"
      sx={{ overflowX: 'auto' }}
      borderRadius={2}
      border={`2px solid ${TABLE_BORDER_COLOR}`}
    >
      <Box px={4} mb={8}>
        <Legends />
      </Box>
      <Box display="flex" columnGap={2} alignItems="center">
        <OverUnderTable startDate={startDate} data={data} />
      </Box>
    </Box>
  );
};

export default OverUnderUtilizationTable;
